"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    formatTripMessageContent: ()=>formatTripMessageContent
});
const external_getPackageTrips_js_namespaceObject = require("./getPackageTrips.js");
const formatTripMessageContent = (trip)=>{
    if (!trip) return '';
    const contents = [
        'Need help with this'
    ];
    if ('PACKAGE' === trip.type) {
        const pkgTrip = (0, external_getPackageTrips_js_namespaceObject.getPackageTrips)(trip);
        contents.push(`${pkgTrip.pkgType || 'package'} reservation.`);
        if (pkgTrip.title) contents.push(`In ${pkgTrip.title}`);
        if (pkgTrip.dateHeader) contents.push(`during ${pkgTrip.dateHeader}.`);
    } else {
        if ('DRIVE' === trip.type) contents.push('car reservation.');
        if ('FLY' === trip.type) contents.push('flight reservation.');
        if ('STAY' === trip.type) contents.push('hotel reservation.');
        if (trip.title) contents.push(`In ${trip.title}`);
        if (trip.dateHeader) contents.push(`during ${trip.dateHeader}.`);
    }
    return contents.join(' ');
};
exports.formatTripMessageContent = __webpack_exports__.formatTripMessageContent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "formatTripMessageContent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
